import { Question } from "./question";

interface AnswerData {
  id?: number;
  value?: number;
  questionId?: number;
  evaluationAthleteId?: number;
  athleteId?: number;
  coachId?: number;
  createDate?: string;
  createrId?: number;
  updateDate?: string;
  updaterId?: number;
  deleteDate?: string;
  deleterId?: number;

  question?: Question;
}

export class Answer {
  public static getNonTranslatableFields(): string[] { return ['id', 'value', 'questionId', 'evaluationAthleteId', 'athleteId', 'coachId', 'createDate', 'createrId', 'updateDate', 'updaterId', 'deleteDate', 'deleterId']; }
  public static getTranslatableFields(): string[] { return []; }
  public static getFields(): string[] { return ['id', 'value', 'questionId', 'evaluationAthleteId', 'athleteId', 'coachId', 'createDate', 'createrId', 'updateDate', 'updaterId', 'deleteDate', 'deleterId']; }
  public static getKeyFields(): string[] { return ['id']; }

  id?: number;
  value?: number;
  questionId?: number;
  evaluationAthleteId?: number;
  athleteId?: number;
  coachId?: number;
  createDate?: string;
  createrId?: number;
  updateDate?: string;
  updaterId?: number;
  deleteDate?: string;
  deleterId?: number;

  question?: Question;

  public static fromAPI(data: AnswerData): Answer {
    if (data.question) data.question = Question.fromAPI(data.question);
    return new Answer(data);
  }

  public static fromAPIList(data: AnswerData[]): Answer[] {
    return data.map((item: AnswerData) => Answer.fromAPI(item));
  }

  constructor({id, value, questionId, evaluationAthleteId, athleteId, coachId, createDate, createrId, updateDate, updaterId, deleteDate, deleterId,
              question} : AnswerData) {
    this.id = id;
    this.value = value;
    this.questionId = questionId;
    this.evaluationAthleteId = evaluationAthleteId;
    this.athleteId = athleteId;
    this.coachId = coachId;
    this.createDate = createDate;
    this.createrId = createrId;
    this.updateDate = updateDate;
    this.updaterId = updaterId;
    this.deleteDate = deleteDate;
    this.deleterId = deleterId;

    this.question = question;
  }

  public toJson(): Object {
    return {
      id: this.id,
      value: this.value,
      questionId: this.questionId,
      evaluationAthleteId: this.evaluationAthleteId,
      athleteId: this.athleteId,
      coachId: this.coachId,
      createDate: this.createDate,
      createrId: this.createrId,
      updateDate: this.updateDate,
      updaterId: this.updaterId,
      deleteDate: this.deleteDate,
      deleterId: this.deleterId
    };
  }
}
